import React from "react";
import {Checkbox, Form, Input } from 'antd';

const FormItem = Form.Item;

/**
 * A form to search for another resource. It has two fields, name and sso, in order to search for a user.
 */
 class FindResourceForm extends React.Component {
    state = {
        confirmDirty: false,
        autoCompleteResult: [],
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({confirmDirty: this.state.confirmDirty || !!value});
    }

    render() {
        //const {getFieldDecorator} = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
        };

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Item label="Search for a Resource By Name OR SSO" />
                {
                    !this.props.isValid ?
                    <FormItem style={{color: 'red'}} label="Please enter a value in atleast one field" />
                    : null
                }
                <FormItem
                    {...formItemLayout}
                >
                    <Input
                      name="name"
                      value={this.props.findResourceFields.name}
                      onChange={this.props.handleSearchFieldChange}
                      onKeyDown={this.props.handleSearch}
                      size={'large'}
                      placeholder={'Resource name'}/>
                </FormItem>
                <br />
                <FormItem
                    {...formItemLayout}
                >
                    <Input
                      name="sso"
                      value={this.props.findResourceFields.sso}
                      onChange={this.props.handleSearchFieldChange}
                      size={'large'}
                      placeholder={'SSO'}/>
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    <Checkbox
                      name="withDisabled"
                      checked={this.props.findResourceFields.withDisabled}
                      onChange={this.props.handleSearchFieldChange}
                      size={'large'}
                      placeholder={'Inactive Resources'}>
                          Inactive Resources
                    </Checkbox>
                </FormItem>
            </Form>
        );
    }
}

export const WrappedFindResourceForm = Form.create()(FindResourceForm);



// WEBPACK FOOTER //
// ./src/Components/Schedule/FindResourceForm.js